// Paleta derivada del logo de Skach: gradiente cian eléctrico -> azul eléctrico.
export const brand = {
  cyan: {
    main: "#22D9EE",
    dark: "#00B8D4",
    light: "#6FEBFA",
  },
  blue: {
    main: "#3A5CFF",
    dark: "#2B3EF0",
    light: "#7B8FFF",
  },
};

export const darkPalette = {
  mode: "dark",
  primary: {
    main: brand.cyan.main,
    dark: brand.cyan.dark,
    light: brand.cyan.light,
    contrastText: "#0A0B12",
  },
  secondary: {
    main: brand.blue.main,
    dark: brand.blue.dark,
    light: brand.blue.light,
    contrastText: "#0A0B12",
  },
  background: {
    default: "#14151f",
    paper: "#1B1D29",
  },
  text: {
    primary: "#E7E9F3",
    secondary: "#9CA3B8",
  },
  divider: "rgba(255,255,255,0.08)",
  success: { main: "#2ED9A8" },
  error: { main: "#FF6B7A" },
  warning: { main: "#FFB454" },
  info: { main: "#22D9EE" },
};

export const lightPalette = {
  mode: "light",
  primary: {
    main: "#0EA5C4",
    dark: "#0B7F98",
    light: "#5FD3E8",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#2B3EF0",
    dark: "#1E2BB8",
    light: "#7B8FFF",
    contrastText: "#FFFFFF",
  },
  background: {
    default: "#F5F6FA",
    paper: "#FFFFFF",
  },
  text: {
    primary: "#1A1C26",
    secondary: "#5C6178",
  },
  divider: "rgba(20,21,31,0.08)",
  success: { main: "#0F9D74" },
  error: { main: "#E5484D" },
  warning: { main: "#D98A1A" },
  info: { main: "#0EA5C4" },
};
